import { render, staticRenderFns } from "./IsOlder.vue?vue&type=template&id=c8c3fade&scoped=true&lang=pug&"
import script from "./IsOlder.vue?vue&type=script&lang=js&"
export * from "./IsOlder.vue?vue&type=script&lang=js&"
import style0 from "./IsOlder.vue?vue&type=style&index=0&id=c8c3fade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c3fade",
  null
  
)

export default component.exports